<template>
  <section ref="pageRef" >
  <div class="max-w-4xl mx-auto flex flex-col items-center gap-10 px-4">
    <!-- Hero -->
    <section class="relative w-screen h-[500px] md:h-[600px] flex items-center justify-center text-center bg-gradient-to-br from-blue-100 via-green-100 to-blue-200 overflow-hidden">
  <!-- Overlay für besseren Kontrast -->
  <div class="absolute inset-0 bg-black/20"></div>

  <!-- Hero Content -->
  <div class="relative z-10 px-4 max-w-4xl mx-auto">
    <h1 class="text-3xl md:text-4xl lg:text-5xl font-semibold text-gray-800 leading-snug">
      Dr. Melissa McCallum –<br> Counselling Psychologist
    </h1>
    <div class="w-24 h-px bg-gray-400 mx-auto my-4"></div>
    <p class="text-xl md:text-2xl text-gray-700">
      Therapy for adults · Online · HCPC accredited
    </p>
  </div>
</section>





      <!-- Intro -->
      <div class="text-gray-800 max-w-xl bg-gray-50 rounded-lg p-6 shadow-sm">
        <h2 class="text-3xl font-semibold mb-4 text-gray-800">Hello, I'm Melissa</h2>
        <p class="mb-4 text-lg leading-relaxed">
          I'm a fully qualified HCPC registered counselling psychologist based in Swindon (SN1), offering therapy for adults (18+) in a safe and confidential environment – online.
        </p>
        <p class="text-lg leading-relaxed">
          My integrative approach combines psychodynamic, person-centred, and CBT methods tailored to your needs.
        </p>
        <div class="mt-6 flex flex-col items-center gap-2">
          <router-link
              to="/contact"
              class="inline-block bg-gray-800 text-white px-6 py-2 rounded hover:bg-gray-700 transition shadow-md"
          >
            Book a Session
          </router-link>
          
        </div>
      </div>

      <div class="mt-6 flex items-center gap-4">
        <a href="https://www.hcpc-uk.org" target="_blank" rel="noopener">
          <img src="/registration.webp" alt="HCPC Registered Logo" class="h-16 w-auto" />
        </a>
        <p class="text-sm text-gray-700">
          HCPC Registration ID: <span class="font-bold underline">PYL045087</span>
        </p>
      </div>
    </div>

    <div class="my-12 border-t border-gray-200"></div>

    <!-- Qualifications -->
    <div class="mt-20 max-w-4xl mx-auto text-gray-800">
      <h3 class="text-2xl font-semibold mb-6 text-center text-gray-800">Qualifications</h3>
      <div class="bg-gray-50 border border-gray-200 rounded p-6 mb-6 flex items-start gap-4 shadow-sm">
        <div class="w-12 h-12 flex-shrink-0"></div>
        <div>
          <p class="font-medium">Verified by Psychology Today</p>
          <p class="text-sm text-gray-700">Registered with Health & Care Professions Council</p>
        </div>
      </div>
      <div class="grid md:grid-cols-2 gap-6">
        <div class="bg-white border border-gray-200 rounded p-4 shadow-sm">
          <h4 class="font-semibold mb-2">Education & Experience</h4>
          <p class="text-sm">In practice for 6 years</p>
          <p class="text-sm">Professional Doctorate in Counselling Psychology (DPsych), Graduated 2024</p>
        </div>
        <div class="bg-white border border-gray-200 rounded p-4 shadow-sm">
          <h4 class="font-semibold mb-2">Additional Credentials</h4>
          <ul class="text-sm space-y-1">
            <li>Member – Health & Care Professions Council (HCPC)</li>
            <li>Registration ID: <span class="text-gray-500">PYL045087</span></li>
            <li>Title: Counselling Psychologist</li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Approaches -->
    <div class="mt-16 mb-16">
      <h3 class="text-2xl font-semibold mb-6 text-center text-gray-800">Therapeutic Approaches</h3>
      <div class="grid sm:grid-cols-2 md:grid-cols-3 gap-4 text-gray-700 max-w-4xl mx-auto">
        <span class="bg-gray-50 px-4 py-2 rounded">Cognitive Behavioural (CBT)</span>
        <span class="bg-gray-50 px-4 py-2 rounded">Compassion Focused</span>
        <span class="bg-gray-50 px-4 py-2 rounded">Culturally Sensitive</span>
        <span class="bg-gray-50 px-4 py-2 rounded">Family Systems</span>
        <span class="bg-gray-50 px-4 py-2 rounded">Humanistic</span>
        <span class="bg-gray-50 px-4 py-2 rounded">Integrative</span>
        <span class="bg-gray-50 px-4 py-2 rounded">Interpersonal</span>
        <span class="bg-gray-50 px-4 py-2 rounded">Mindfulness-Based (MBCT)</span>
        <span class="bg-gray-50 px-4 py-2 rounded">Person-Centred</span>
        <span class="bg-gray-50 px-4 py-2 rounded">Psychodynamic</span>
        <span class="bg-gray-50 px-4 py-2 rounded">Relational</span>
        <span class="bg-gray-50 px-4 py-2 rounded">Strength-Based</span>
        <span class="bg-gray-50 px-4 py-2 rounded">Transactional Analysis</span>
        <span class="bg-gray-50 px-4 py-2 rounded">Trauma Focused</span>
      </div>
    </div>

    <!-- Client Focus + Specialisms + Fees (gleichbleibend) -->

    <div class="mt-20 text-center text-gray-500 italic text-lg">
      “You are not broken. You are breaking through.”
    </div>
  </section>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import gsap from 'gsap'

const pageRef = ref(null)

onMounted(() => {
  gsap.from(pageRef.value, {
    opacity: 0,
    scale: 0.95,
    duration: 1.2,
    ease: 'power2.out'
  })
})
</script>